module.exports = __webpack_public_path__ + "static/ndrc-logo-d64f48080fbfc3f5586ea60277c0b6b7.svg";